import { render, staticRenderFns } from "./listClassic.vue?vue&type=template&id=c9c002c0&scoped=true"
import script from "./listClassic.vue?vue&type=script&lang=js"
export * from "./listClassic.vue?vue&type=script&lang=js"
import style0 from "./listClassic.vue?vue&type=style&index=0&id=c9c002c0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c9c002c0",
  null
  
)

export default component.exports